import {WixSdk} from '@wix/js-sdk-wrapper';

export const getBiToken = () => {
  return WixSdk.Utils.getInstanceValue('biToken');
};
